export const getDefaultSiteIndex = (sites: { isDefault?: boolean }[]): number => {
  const index = sites?.findIndex((site) => site?.isDefault) ?? -1;
  return index >= 0 ? index : 0;
};
